import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  EnterpriseSearchService,
  Basket,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-send-pdf-by-email',
  templateUrl: './send-pdf-by-email.component.html',
  styleUrls: ['./send-pdf-by-email.component.scss'],
  standalone: false
})
export class SendPdfByEmailComponent extends WithSubscriptionComponent implements OnInit {
  id = '';
  email: string = null;
  emailsList: string[] = [];
  addEmailForm: FormGroup;
  emailsForm: FormGroup;
  constructor(
    public activeModal: NgbActiveModal,
    private searchService: EnterpriseSearchService,
    private fb: FormBuilder
  ) {
    super();
  }

  get emails() {
    return this.emailsForm.controls['emails'] as FormArray;
  }

  ngOnInit(): void {
    this.emailsForm = new FormGroup({
      emails: new FormArray([
        new FormGroup({
          selected: new FormControl(true),
          email: new FormControl(this.email)
        })
      ])
    });

    this.addEmailForm = new FormGroup({
      selected: new FormControl(true),
      email: new FormControl('', [Validators.email])
    });
    this.createEmailList();
  }

  addEmail() {
    const emailForm = this.fb.group({
      selected: true,
      email: this.addEmailForm.get('email').value
    });
    this.emails.push(emailForm);

    this.emailsForm.markAsDirty();
    // set default value
    this.addEmailForm.setValue({ selected: true, email: '' });
    this.createEmailList();
  }

  createEmailList() {
    this.emailsList = [];
    this.emailsForm.value.emails.forEach((item) => {
      if (item.selected) {
        this.emailsList = this.emailsList.concat(item.email);
      }
    });
  }

  submit() {
    this.subscribe(
      this.searchService.emailBasket(this.id, this.emailsList),

      () => this.activeModal.close(true)
    );
  }
}

LightningModalTypes.SendPdfByEmailComponent.component = SendPdfByEmailComponent;
